import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ThumbnailAndNotification from "../../../../../../components/WMS/Mobile/ThumbnailAndNotification";
import {WmsContainerType} from "../../../../../../utils/WMSContainerType";
import trolleyIcon from "assets/img/wms/trolley.svg";
import shelfIcon from "assets/img/wms/shelf.svg";
import scanBoxIcon from "assets/img/wms/scanBox.svg";
import workstationIcon from "assets/img/wms/workstation.svg";
import boxGroupedIcon from "assets/img/wms/boxGrouped.svg";
import locationIcon from "assets/img/wms/location.svg";
import dangerIcon from "assets/img/wms/danger.svg";
import {FormattedMessage} from "react-intl";
import Badge from "../../../../../../components/Badge";
import {grey300} from "../../../../../../assets/jss/main";
import CustomButton from "../../../../../../components/CustomButton";
import {LogsContext} from "../../../logsContext";
import ArrowDownIcon from "../../../../../../components/icons/ArrowDownIcon";

const CONTAINER_ICONS = {
    [WmsContainerType.TROLLEY]: trolleyIcon,
    [WmsContainerType.SHELF]: shelfIcon,
    [WmsContainerType.HIVE]: scanBoxIcon,
    [WmsContainerType.PACKING_STATION]: workstationIcon,
    [WmsContainerType.TIPPER]: boxGroupedIcon,
    [WmsContainerType.CC]: locationIcon,
};

ContainerItem.propTypes = {
 container: PropTypes.object.isRequired
};

function ContainerItem({container}) {
    const {seeItemLog, itemId, selectedItemIdentifier, selectedItemBarcode} = useContext(LogsContext)

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ArrowDownIcon/>}>
                <Grid container flexWrap={"nowrap"} alignItems={"center"}>
                    <ThumbnailAndNotification link={CONTAINER_ICONS[container.type] ?? dangerIcon} alt={container.type}/>
                    <Grid container direction={"column"} marginLeft={2} gap={"8px"}>
                        <span>{container.fullName}</span>
                    </Grid>
                    <Badge color={"default"} rounded isBold>
                        <FormattedMessage id={`wms.container.type.name.${container.type}`}/>
                    </Badge>
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor: grey300, padding: 0}}>
                <Grid container direction={"column"} sx={{padding: "8px"}}>
                    <Grid container>
                        <FormattedMessage id={"wms.logs.container.member.label"}/>
                        {container.user ?? "N/A"}
                    </Grid>
                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.container.codebar.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {container.codebar}
                        </Badge>
                    </Grid>
                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.container.itemCount.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {container.itemCount}
                        </Badge>
                    </Grid>
                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.container.shipmentCount.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {container.shipmentCount}
                        </Badge>
                    </Grid>
                    {container.type === WmsContainerType.HIVE && container.maxCapacity && (
                        <Grid container>
                            <Badge color={"error"} rounded isBold>
                                <FormattedMessage id={"wms.logs.container.maxCapacity.label"}/>
                            </Badge>
                        </Grid>
                    )}
                    {container.shippingMethods?.length > 0 && (
                        <Grid container flexWrap={'wrap'} alignItems={"center"} gap={"4px"}>
                            <span><FormattedMessage id={"wms.logs.container.shippingMethod.label"}/></span>
                            {container.shippingMethods.map((name) => (
                                <Badge key={name} color={"default"} rounded isBold>
                                    {name}
                                </Badge>
                            ))}
                        </Grid>
                    )}

                    <Grid item sx={{marginTop: "8px"}}>
                        <CustomButton fullWidth onClick={() => {
                            itemId.current = container.codebar
                            selectedItemIdentifier.current = container.fullName
                            selectedItemBarcode.current = container.codebar
                            seeItemLog()
                        }}>
                            <FormattedMessage id={"wms.logs.itemList.seeTheLogs"}/>
                        </CustomButton>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default ContainerItem;